import { render, staticRenderFns } from "./ManualCompraDiretaFornecedor.vue?vue&type=template&id=446d7838&scoped=true"
import script from "./ManualCompraDiretaFornecedor.vue?vue&type=script&lang=js"
export * from "./ManualCompraDiretaFornecedor.vue?vue&type=script&lang=js"
import style0 from "./ManualCompraDiretaFornecedor.vue?vue&type=style&index=0&id=446d7838&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d7838",
  null
  
)

export default component.exports